import moment from "moment";
import CardTable from "../../components/card/CardTable";
import { ColumnInterface } from "../../components/table/typings";
import { useQueries } from "../../hooks/useQueries";
import { APP_API_URL } from "../../config/api";
import useHeaderFunctionPage from "../../hooks/useHeaderFunctionPage";
import { useLocation } from "react-router-dom";
import { DATE_TIME_FORMAT } from "../../config/global";
import { BadgeCircleCheck, BadgeRounded } from "../../components/badge/Badge";
import { useMutate } from "../../hooks/useMutations";
import { toast } from "react-toastify";

export default function CampaignMailPage() {
    /**
     * Hooks
     */
    const { state } = useLocation();
    const campaign = state?.campaign;
    //console.log("campaign", campaign);
    const { title, queryKey, pagination, setPagination, status, setStatus } = useHeaderFunctionPage({
        baseApiUrl: `mails-${campaign.id}`,
        title: `Détails sur la campagne "${campaign.name}"`,
    });

    /**
     * Query
     */
    const { data: datas, isLoading } = useQueries(
        status ?
            APP_API_URL +
            `mails/${campaign.id}?page=${pagination.page}&perPage=${pagination.perPage}&status=${status}`
            :
            APP_API_URL +
            `mails/${campaign.id}?page=${pagination.page}&perPage=${pagination.perPage}`,
        queryKey
    );
    const { mutateAsync: downloadExcel, isLoading: downloadLoading } = useMutate(
          status ?
        `${APP_API_URL}export-mails/${campaign.id}?status=${status}`
        :`${APP_API_URL}export-mails/${campaign.id}`,
        "get"
    );

    /**
     * Functions
     */
    const handleDownloadExcel = async () => {

        try {
            const response = await downloadExcel(null);

            const blob = new Blob([response!.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", "contacts.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(downloadUrl);

            toast.success("Fichier téléchargé !");
        } catch (error) {
            toast.error("Erreur lors du téléchargement.");
        }
    };

    /**
     * Columns Table
     */
    const columns: ColumnInterface[] = [
        {
            title: "Email",
            key: "email",
            dataIndex: "email",
        },
        {
            title: "Status",
            key: "status",
            dataIndex: "status",
            render: (element: any) => {
                if (element.status === "sent") {
                    return (
                        <BadgeRounded className="bg-soft-secondary" text={element.status} />
                    );
                }
                else if (
                    element.status === "Delivery"
                ) {
                    return (
                        <BadgeRounded className="bg-soft-success" text={"Delivered"} />
                    );
                }
                else if (
                    element.status === "spam"
                ) {
                    return (
                        <BadgeRounded className="bg-soft-success" text={element.status} />
                    );
                } else {
                    return (
                        <BadgeRounded className="bg-soft-danger" text={element.status} />
                    );
                }
            },
        },
        {
            title: "Mail ouvert",
            key: "sent_at",
            render: (element: any) => (
                <>
                    <BadgeCircleCheck active={element.is_open} />
                </>
            ),
        },
        {
            title: "Envoyé à",
            key: "sent_at",
            render: (element: any) => (
                <>{moment(element.sent_at).format(DATE_TIME_FORMAT)}</>
            ),
        },
        {
            title: "Date",
            key: "created_at",
            render: (element: any) => (
                <>{moment(element.created_at).format(DATE_TIME_FORMAT)}</>
            ),
        },
    ];

    /**
     * UI
     */
    return (
        <>
            <CardTable
                columns={columns}
                title={title}
                loading={isLoading}
                datas={datas?.data}
                pagination={pagination}
                setStatus={setStatus}
                status={status}
                haveFilter={true}
                setPagination={setPagination}
                tableClassName="text-center"
                id={campaign.id}
                loadingExport={downloadLoading}
                handleDownloadExcel={handleDownloadExcel}
            />
        </>
    );
}
